import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './theme-snaplayer.css'
import './utils/quietConsole'
import './editor/utils/mutationObserverGuard'
import { initChunkErrorHandler, clearChunkErrorState } from './utils/chunkErrorHandler'
import { initSentry } from './lib/sentry'

// Error monitoring (no-op until VITE_SENTRY_DSN is set).
initSentry();

// Initialize chunk error handling to auto-reload on stale deployments
initChunkErrorHandler();

// Clear error state on successful load
clearChunkErrorState();

// Track editor init time ASAP to suppress early dirty marks
if (typeof window !== 'undefined') {
  (window as any).__editorInitTime = Date.now();
}

createRoot(document.getElementById("root")!).render(<App />);
